import { Popover, PopoverSurface, PopoverTrigger, tokens } from '@fluentui/react-components';
import { ITokenUsageViewDetails } from 'shared/models/TokenUsage';

interface ITokenUsageBar {
    details: ITokenUsageViewDetails;
    totalUsage: number;
}

export const TokenUsageBar: React.FC<ITokenUsageBar> = ({ details, totalUsage }) => {
    const percentage = details.usageCount / totalUsage;
    const barWidth = percentage * 500;

    return (
        <Popover
            openOnHover
            mouseLeaveDelay={0}
            positioning={{
                position: 'above',
            }}
            withArrow
            appearance="inverted"
        >
            <PopoverTrigger>
                <div
                    key={details.legendLabel}
                    style={{
                        backgroundColor: details.color,
                        height: tokens.spacingVerticalMNudge,
                        width: `${barWidth}px`,
                    }}
                />
            </PopoverTrigger>
            <PopoverSurface>{`${details.legendLabel} (${details.usageCount})`}</PopoverSurface>
        </Popover>
    );
};
